__turbopack_context__.v({
  "HeroSection": "HeroSection-module__Vok4CG__HeroSection",
  "image": "HeroSection-module__Vok4CG__image",
  "slide": "HeroSection-module__Vok4CG__slide",
  "slider": "HeroSection-module__Vok4CG__slider",
});
